import React from "react";

export default function ScoreFilterSlider({ filterThreshold, onChange }) {
	return (
		<div style={{ marginTop: 30 }}>
			<h4 style={{ marginBottom: 10 }}>Filter Display by Score</h4>
			<input
				type="range"
				min="0"
				max="1"
				step="0.01"
				value={filterThreshold}
				onChange={(e) => onChange(parseFloat(e.target.value))}
				style={{ width: "100%" }}
			/>
			<div style={{ marginTop: 4, fontSize: 14 }}>
				Current: {filterThreshold.toFixed(2)}
			</div>
		</div>
	);
}
